export const slugFromMdPath = (path: string): string => {
  const pathArray = path.split("/")
  const slug = pathArray[pathArray.length - 1]

  return slug.replace(/.md$/, "")
}
